module.exports = __webpack_public_path__ + "img/process-4.06979d55.png";